import { render, staticRenderFns } from "./activeSection.vue?vue&type=template&id=ebb10474&"
import script from "./activeSection.vue?vue&type=script&lang=js&"
export * from "./activeSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports